import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

const TCBanner = ({ clientData, onCloseBanner }) => {
  const axios = useAxiosPrivate()

  return (
    <>
      {clientData?.terms?.hide_terms_banner === false ? (
        <>
          {clientData.terms.accepted_terms === true &&
          clientData.terms.accepted_terms_at ? (
            <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-2 px-4 text-sm mb-4 flex justify-between items-center">
              <p className="font-semibold">
                The Terms and Conditions have been accepted.
              </p>
            </div>
          ) : clientData.terms.terms_reminder_at?.day_14 ? (
            <div className="bg-red-100 border-l-4 border-red-600 text-red-700 p-2 px-4 text-sm mb-4">
              <p className="font-semibold">
                Terms and Conditions: The client hasn't accepted the T&Cs and a
                request to discharge has been sent
              </p>
            </div>
          ) : clientData.terms.terms_reminder_at?.day_9 ? (
            <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2 px-4 text-sm mb-4">
              <p className="font-semibold">
                Terms and Conditions: Second Reminder has been sent.
              </p>
            </div>
          ) : clientData.terms.terms_reminder_at?.day_2 ? (
            <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2 px-4 text-sm mb-4">
              <p className="font-semibold">
                Terms and Conditions: Reminder has been sent.
              </p>
            </div>
          ) : clientData.terms.notified_terms === true &&
            clientData.terms.notified_terms_at ? (
            <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2 px-4 text-sm mb-4">
              <p className="font-semibold">
                Terms and Conditions have been sent to the client.
              </p>
            </div>
          ) : null}
        </>
      ) : (
        <div className="bg-blue-100 border-l-4 border-blue-300 text-blue-700 p-2 px-4 text-sm mb-4">
          <p className="font-semibold">Client did not need to accept T&Cs.</p>
        </div>
      )}
    </>
  )
}

export default TCBanner
